import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withMixpanel } from 'Utils/mixpanel';

import Icon from 'Components/Icon';
import BetPill from 'Components/Pills/BetPill';
import TextWrapper from 'Components/TextWrapper';
import History from 'Store/history';
import { closeModal } from 'Store/actions';
import {
  URL_MAP_BY_TYPE,
  EVENT_FIELD_MAPPING,
  EVENT_STREAM_ICONS,
  COUPON_PLAYED,
  EVENT_MATCH_STATUS_TYPES,
  MOTORSPORTS
} from 'Store/constants/sportTypes';
import { getEventStatusUpdate, getCouponChangeOdds } from 'Store/actions';
import SportTypeIcon from 'Components/SportTypeIcon';
import EnvironmentManager from 'Utils/environmentManager';
import { getStreamInfoDetail } from 'Utils/getStreamInfoDetail';
import { classnames } from 'Utils/classnames';
import { Badge } from 'Components/Badge';
import Modal from 'Components/Modal';
import Message from 'Components/Modal/Message';
import { dotConverter } from 'Utils/converters';
import { trackSelectItemTribun } from 'Utils/analytics';

const {
  hasLiveStream,
  channel
} = EVENT_FIELD_MAPPING;

class CouponRowDetails extends Component {
  static propTypes = {
    getEventStatusUpdate: PropTypes.func,
    toggleAction: PropTypes.func,
    openModal: PropTypes.func,
    closeModal: PropTypes.func,
    event: PropTypes.object,
    score: PropTypes.object,
    eventStatus: PropTypes.object,
    children: PropTypes.node,
    systemCoupon: PropTypes.bool,
    isSelected: PropTypes.bool,
    couponStatus: PropTypes.string,
    mixpanel: PropTypes.object,
    isFromTribunV2: PropTypes.bool,
    loginStatus: PropTypes.bool,
    auth: PropTypes.object,
    childCouponsSize: PropTypes.number,
    modalData: PropTypes.object,
    getCouponChangeOdds: PropTypes.func,
    couponId: PropTypes.string,
    playDate: PropTypes.number,
    data: PropTypes.object,
    tabType: PropTypes.string,
    topWinEnabled: PropTypes.bool,
  };

  constructor () {
    super();

    this.state = {
      showStreamInfoPopup: false
    };
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const { showStreamInfoPopup } = this.state;
    if (showStreamInfoPopup)
      setTimeout(() => {
        this.setState({
          showStreamInfoPopup: false
        });
      }, 2000);
  }

  _handleMatchStatus = status => {
    const { openModal, score } = this.props;

    if (EVENT_MATCH_STATUS_TYPES.POSTPONED.includes(score?.matchStatus)) {
      return <div className="postponed">
        <span>ERT</span>
        <i className="bly bly-info-circle-inverse bly-size14 bly-blue-grey" onClick={ e => {
          e.stopPropagation();
          openModal('postponedModal');
        } } />
      </div>;
    }

    const { loginStatus, tabType } = this.props;
    const pathname = History.location?.pathname;
    const isCouponSharePage = pathname.includes('/iddaa/kupon/') || pathname.includes('/spor-toto/kupon/');
    const isNotLoggedInAndNotInKuponlarim = !loginStatus && !['won', 'odd', 'earning'].includes(tabType) && !pathname.includes('kuponlarim') && !pathname.includes('kupon-ozet') && !isCouponSharePage;

    switch (status) {
      case 'WINNING':
        return (
          <Icon
            className="ic_ticket_win--continue"
            iconName={ isNotLoggedInAndNotInKuponlarim ? 'svgNotLoginWinLose' : 'svgTicketWin' }
          />
        );
      case 'WON':
        return (
          <Icon
            iconName={ isNotLoggedInAndNotInKuponlarim ? 'svgNotLoginWinLose' : 'svgTicketWin' }
          />
        );
      case 'LOST':
      case 'LOSING':
        return (
          <Icon
            className={ status === 'LOSING' ? 'ic_ticket_lose--continue' : undefined }
            iconName={ isNotLoggedInAndNotInKuponlarim ? 'svgNotLoginWinLose' : 'svgTicketLose' }
          />
        );
      case 'DRAWING':
        return <Icon iconName="svgDrawing" className="ic_ticket_refund--continue" />;
      case 'DRAW':
      case 'REFUND':
        return <Icon iconName="svgDrawing" />;
      case 'UNEVALUATED':
      default:
        return null;
    }
  };

  handleEventClick () {
    const { event, couponStatus, isFromTribunV2, systemCoupon = false } = this.props;
    if (systemCoupon || event.outright) return;

    const url = `/mac-karti/${URL_MAP_BY_TYPE[event.sportType]}/${event.eventId}`;
    const pathname = History.location.pathname;

    if (!pathname.startsWith(url)) {
      History.push(url);
    }
    if (couponStatus === 'COUPON_PLAYED') {
      this.props.mixpanel.track('View Event Detail', {
        'Click Point': 'Kuponlarım - Devam Eden',
      });
    }
    if (couponStatus === 'COUPON_LOST') {
      this.props.mixpanel.track('View Event Detail', {
        'Click Point': 'Kuponlarım - Kaybeden',
      });
    }
    if (couponStatus === 'COUPON_WON') {
      this.props.mixpanel.track('View Event Detail', {
        'Click Point': 'Kuponlarım - Kazanan',
      });
    }
    if (couponStatus === 'COUPON_SAVED') {
      this.props.mixpanel.track('View Event Detail', {
        'Click Point': 'Kuponlarım - Kayıtlı',
      });
    }
    if (isFromTribunV2 && pathname === '/tribun/tribun-uzay-kuponlar') {
      this.props.mixpanel.track('View Event Detail', {
        'Click Point': 'Tribün - Uzay Kuponları',
      });
    }
    if (isFromTribunV2 && pathname !== '/tribun/tribun-uzay-kuponlar') {
      this.props.mixpanel.track('View Event Detail', {
        'Click Point': 'Tribün - Kupon',
      });
    }
  }


  renderStreamInfo= () => {
    const { event, couponStatus } = this.props;
    const { showStreamInfoPopup } = this.state;
    const currentTime = +new Date;
    let content = null;

    if (
      !event[hasLiveStream]
      || !EVENT_STREAM_ICONS[event[hasLiveStream]]
      || (!event[channel] && getStreamInfoDetail(event[hasLiveStream]).other)
      || couponStatus !== COUPON_PLAYED
      || (currentTime > event.eventDate) && getStreamInfoDetail(event[hasLiveStream]).other
      || event.officialResult
    ) {
      return null;
    }

    if ((currentTime > event.eventDate) && !getStreamInfoDetail(event[hasLiveStream]).other) {
      content = <span className="stream-info-container">
        <Icon
          className="coupon-row__betslip__header__icons-live"
          iconName={ 'svgWatchStackCircleFilledWithText' }
          onClick={ () => {
            this.props.mixpanel.track('Click Broadcast Icon', {
              'Screen Name': 'Kuponlarım'
            });
            this.redirectToMatchCard('oranlar', 'stream');
          } }
        />
      </span>;
    } else {
      let popupText = '';

      if (getStreamInfoDetail(event[hasLiveStream]).bilyoner || getStreamInfoDetail(event[hasLiveStream]).both) {
        popupText = `${EnvironmentManager.getMessageText({ key: 'bilyoner_tv_live_message' })}`;

        if (event[channel] && getStreamInfoDetail(event[hasLiveStream]).both) {
          popupText = `${popupText} <hr> ${EnvironmentManager.getMessageText({ key: 'bilyoner_tv_statik_message' })} &nbsp;<b>${event[channel]}</b>`;
        }
      } else if (event[channel] && getStreamInfoDetail(event[hasLiveStream]).other) {
        popupText = `${EnvironmentManager.getMessageText({ key: 'bilyoner_tv_statik_message' })} <b>${event[channel]}</b>`;
      }

      content = <span data-test="icon-is-live-stream" className="stream-info-container">
        <Icon
          className="coupon-row__betslip__header__icons"
          iconName={ EVENT_STREAM_ICONS[event[hasLiveStream]] }
          onClick={ () => {
            this.props.mixpanel.track('Click Broadcast Icon', {
              'Screen Name': 'Kuponlarım'
            });
            if (!showStreamInfoPopup) {
              this.setState({
                showStreamInfoPopup: true
              });
            }
          } }
        />
        { showStreamInfoPopup
          && <div
            className={ classnames({
              'stream-info-popup': true
            }) }
            dangerouslySetInnerHTML={ { __html: popupText } }
          />
        }
      </span>;
    }

    return event.isLive ? this.renderStreamInfoLive() : content;
  }

  renderStreamInfoLive = () => {
    const { event } = this.props;
    if (!event[hasLiveStream] || getStreamInfoDetail(event[hasLiveStream]).other) {
      return null;
    }

    return <span className="stream-info-container">
      <Icon
        className="coupon-row__betslip__header__icons-live"
        iconName={ 'svgWatchStackCircleFilledWithText' }
        onClick={ () => {
          this.redirectToMatchCard('oranlar', 'stream');
        } }
      />
    </span>;
  };

  redirectToMatchCard = (tabName = '', openSlideName = '') => {
    const { event } = this.props;
    const redirectUrl = `/mac-karti/${URL_MAP_BY_TYPE[event.sportType]}/${event.eventId}/${tabName}`;

    History.push(redirectUrl, { openSlideName });
  };

  prepareTeamNames = (event, eventStatus) => {
    if (event.sportType === MOTORSPORTS) {
      return (
      <>
        <span className='truncate-one-line'>
          { event?.eventName }
        </span>
          { this._handleMatchStatus(eventStatus?.status || event.winningStatus) }
        </>
      );
    }

    if (!event.outright) {
      return (
        <>
          <TextWrapper text={ event?.eventName } limit={ 80 } />
          { this._handleMatchStatus(eventStatus?.status || event.winningStatus) }
        </>
      );
    }

    return (
      <>
        <span>{ event?.eventName }</span>
        { this._handleMatchStatus(event?.winningStatus) }
      </>
    );
  }


  changeOddsClick=()=>{
    this.props.getCouponChangeOdds(this.props.couponId, this.props.event?.marketId).then(res=>{
      this.props.openModal(`changeRatioModal-${this.props.event?.eventId}-${this.props.playDate}`, { changedOdds: res?.changedOdds });
    });
  }


  render () {
    const { data, event, isSelected, eventStatus, isFromTribunV2, systemCoupon, loginStatus, childCouponsSize, closeModal, modalData, playDate, auth, topWinEnabled } = this.props;
    //const calculatedSpecialOddsValue = Math.abs(event.specialOddsValue).toFixed(1);
    // her yerden yollamamak adına false check yaptım buralarda
    const blurry = loginStatus === false ? ' blurry-text' : '';
    const zirveoranCouponsSwitch = EnvironmentManager.getMessageText({ key: 'zirveoran_coupons_switch' }) === 'true';
    const zirveoranTribuneSwitch = EnvironmentManager.getMessageText({ key: 'zirveoran_tribune_switch' }) === 'true';

    const renderChangedOddsModal = () => {
      if (modalData.modalNames.includes(`changeRatioModal-${event?.eventId}-${playDate}`)) {
        return (
          <Modal
            title={ EnvironmentManager.getMessageText({ key: 'title_multiple_coupon_odd_change_popup' }) || 'Oran Değişimi' }
            iconName="svgInfoGreen"
            onClose={ () => closeModal(`changeRatioModal-${event?.eventId}-${playDate}`) }
            buttonArea={ {
              primaryButton: {
                label: EnvironmentManager.getMessageText({ key: 'title_multiple_coupon_odd_change_popup_ok' }) || 'TAMAM',
                onClick: () => {
                  closeModal(`changeRatioModal-${event?.eventId}-${playDate}`);
                }
              }
            } }
          >
            <div className='coupon-row__modal'>
              <span>
                { EnvironmentManager.getMessageText({ key: 'description_multiple_coupon_odd_change_popup' }) || 'Çoklu kupon oynama işlemin sırasında oran değişimi olmuş ve maksimum kazanç tutarın değişmiştir.' }
              </span>
              <div className='coupon-row__modal--title'>
                <div className='coupon-row__modal--title--area'>
                  <span>{ EnvironmentManager.getMessageText({ key: 'title_multiple_coupon_odd_change_popup_count' }) || 'Kupon Adedi' }</span>
                </div>
                <div className='coupon-row__modal--title--middle'/>
                <div className='coupon-row__modal--title--area--right'>
                  <span>
                    { EnvironmentManager.getMessageText({ key: 'title_multiple_coupon_odd_change_popup_odds' }) || 'Oynanan Oran' }
                  </span>
                </div>
              </div>
              <div className='coupon-row__modal--table'>
                { modalData[`changeRatioModal-${event?.eventId}-${playDate}`]?.changedOdds?.map((item, index) =>
                  <>
                    <div className={ index % 2 === 0 ? 'coupon-row__modal--table--area' : 'coupon-row__modal--table--area--white' }>
                      <span>{ item?.count }</span>
                    </div><div className={  index % 2 === 0 ? 'coupon-row__modal--table--area--right' : 'coupon-row__modal--table--area--white--right' }>
                      <span>{ dotConverter(item?.odd) }</span>
                    </div>
                  </>
                ) }
              </div>
            </div>

            <Message type="none"/>
          </Modal>
        );
      }
    };
    const teamNames = this.prepareTeamNames(event, eventStatus);

    const mbsIconArea =  event.isLive ? (
      <div className="coupon-row__participants__live">
        <Badge>
          <i className="bly bly-live bly-white-black"/>
          <span> Canlı </span>
        </Badge>
      </div>
    ) : null;

    const mbsIcon = (isFromTribunV2 ||  systemCoupon ) ? ( // sadece tribünde gösterilicek
      <Icon iconName={ `iconMbs${event.mbs}Betslip` } className='coupon-row__market-odd--mbs-icon' /> ) : null;

    return (
      <>
        <div className="coupon-row__betslip">
          <div className="coupon-row__betslip__header">
            <div className="coupon-row__participants" onClick={ e => {
              e.stopPropagation();
              this.handleEventClick();
              isFromTribunV2 && trackSelectItemTribun(event, auth?.data?.balance);
            } }>
              <SportTypeIcon type={ event.sportType } />
              <span> { teamNames } </span>
              { mbsIconArea }
              { (isFromTribunV2 ? (zirveoranTribuneSwitch && topWinEnabled && data?.couponTopWin?.hasTopWin && event?.topWin?.oddsWithTopWin || (event?.topOdds && topWinEnabled && zirveoranTribuneSwitch)) : (zirveoranCouponsSwitch && data?.couponTopWin?.hasTopWin && event?.topWin?.oddsWithTopWin))
                && <Icon iconName='svgZirveOran'/> }
            </div>
            { this.renderStreamInfo() }
          </div>
          <div className="coupon-row__participants__infos">
            <div className={ `coupon-row__market-name ${blurry} ` }>
              { event.marketName }
            </div>
            <div className="coupon-row__market-odd">

              { mbsIcon }

              <BetPill
                pillStyle="horizontal"
                odd={ event.odds }
                tWinOdd={ (zirveoranCouponsSwitch && data?.couponTopWin?.hasTopWin) && event?.topWin?.oddsWithTopWin || (zirveoranTribuneSwitch && event?.topOdds) }
                hasTopWin={ isFromTribunV2 ? undefined : data?.couponTopWin?.hasTopWin }
                isSelected={ isSelected }
                onClick={ () => loginStatus === false ? null :  this.props.toggleAction(event) }
                betType={ event.marketOutcomeName }
                loginStatus={ loginStatus }/>

              { event.banker ? <Icon iconName="iconBankoActive"/> : null }

              { childCouponsSize > 0 && event?.odds !== event?.clientOdds  && <div className="coupon-row__change-ratio">
                <span>{ dotConverter(event?.clientOdds) }-{ dotConverter(event?.odds) }</span>
                <Icon className="coupon-row__ic" iconName="svgInfoGreen" onClick={ e => {
                  e.stopPropagation();
                  this.changeOddsClick();
                } }/>
              </div> }

            </div>
            { this.props.children }
          </div>
        </div>
        { renderChangedOddsModal() }
      </>
    );
  }
}

const mapStateToProps = state => ({
  modalData: state.modalData,
  auth: state.auth
});

export default connect(mapStateToProps, { getEventStatusUpdate, closeModal, getCouponChangeOdds })(withMixpanel(CouponRowDetails));
